import { Box, Button, styled, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlined from "@mui/icons-material/DeleteOutlined";
import MoreVert from "@mui/icons-material/MoreVert";

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  [theme.breakpoints.up("md")]: {
    width: "360px",
    paddingTop: "40px",
    paddingBottom: "40px",
  },
}));

export const HeaderRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
});

export const TitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

export const Title = styled(Typography)({
  fontWeight: 500,
  fontSize: "24px",
  lineHeight: "32px",
  color: "#414046",
});

export const InfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
  color: theme.palette.icon.primary,
  fontSize: "24px",
}));

export const NewTemplateButton = styled(Button)({
  width: "100%",
  height: "42px",
  backgroundColor: "#F1EEFF",
  border: "0.8px solid #302D84",
  borderRadius: "100px",
  color: "#302D84",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "23px",
  letterSpacing: "0.5px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#E5E0FF",
  },
});

export const TemplatesList = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#FFFFFF",
  borderRadius: "8px",
  overflowY: "auto",
  maxHeight: "calc(100vh - 320px)",
  [theme.breakpoints.down("md")]: {
    maxHeight: "200px",
  },
}));

export const TemplateItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "16px 8px 16px 16px",
  backgroundColor: "#FFFFFF",
  borderBottom: "1px solid #EAEAEA",
  cursor: "pointer",
  "&:last-child": {
    borderBottom: "none",
  },
  "&:hover": {
    backgroundColor: "#FAFAFA",
  },
});

export const TemplateItemContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0,
  gap: "2px",
});

export const TemplateName = styled(Typography)({
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "23px",
  letterSpacing: "0.5px",
  color: "#414046",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  minWidth: 0,
});

export const TemplateDescription = styled(Typography)({
  fontSize: "14px",
  lineHeight: "20px",
  color: "#757475",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  minWidth: 0,
});

export const EditIcon = styled(EditOutlined)(({ theme }) => ({
  color: theme.palette.icon.primary,
  fontSize: "24px",
}));

export const DeleteIcon = styled(DeleteOutlined)(({ theme }) => ({
  color: theme.palette.icon.primary,
  fontSize: "24px",
}));

export const MoreVertIcon = styled(MoreVert)(({ theme }) => ({
  color: theme.palette.icon.primary,
}));

export const LoadingContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "32px",
});

export const EmptyStateText = styled(Box)({
  fontSize: "14px",
  color: "#757475",
  textAlign: "center",
  padding: "16px",
});

export const LoadingOverlay = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  zIndex: 9999,
});

export const ViewAllButton = styled(Button)({
  color: "#302D84",
  fontWeight: 500,
  fontSize: "14px",
  textTransform: "none",
  padding: "4px 8px",
  minWidth: "auto",
});

export const FullScreenContainer = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "#FFFFFF",
  zIndex: 999,
  display: "flex",
  flexDirection: "column",
});

export const FullScreenTemplatesList = styled(Box)({
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  flex: 1,
});
